<template>
  <footer>
    <h6>Pagamento via:</h6>
    <img :src="gatewayImage.image" :srcset="gatewayImage.image2x + ' 2x'">
  </footer>
</template>

<script>
import mercadoPago from '@/assets/images/logo-mercado-pago.png'
import mercadoPago2x from '@/assets/images/logo-mercado-pago@2x.png'

export default {
  name: 'invoiceFooter',
  props: ['gateway'],
  computed: {
    gatewayImage () {
      let gateway = this.gateway || 'mercado-pago'
      let image, image2x

      if (gateway === 'mercado-pago') {
        image = mercadoPago
        image2x = mercadoPago2x
      }

      return { image, image2x }
    }
  }
}
</script>
